'use client';

import IdGeneratorService from '@/services/id-generator.service';
import { RadioButton, type RadioButtonProps } from 'primereact/radiobutton';
import { Controller } from 'react-hook-form';

interface Props extends RadioButtonProps {
	id: string;
	children?: React.ReactNode;
	// biome-ignore lint/suspicious/noExplicitAny: Control will have different structure on each use of the TextInput
	control: any;
	formName?: string;
	label?: string;
}

const RadioButtonInput = (props: Props) => {
	const idService = new IdGeneratorService(props.formName);
	const idGenerated = idService.generateFormInputIds(props.id);

	return (
		<Controller
			control={props.control}
			name={props.id}
			render={({ field }) => {
				return (
					<>
						<label
							className={
								props.className ??
								'cursor-pointer text-lg text-onSurface'
							}
							htmlFor={`${idGenerated.id}-${props.value}`}
						>
							{props.children ?? props.label ?? ''}
						</label>
						<RadioButton
							checked={field.value === props.value}
							data-testid={idGenerated.testId}
							id={idGenerated.id}
							inputId={`${idGenerated.id}-${props.value}`}
							name={props.id}
							onChange={field.onChange}
							pt={
								props.pt ?? {
									box: {
										className: 'tc-radio-input',
									},
									icon: {
										className: 'tc-radio-icon',
									},
								}
							}
							// The value for this one should come from the props since
							// a radio button group will have different values for each
							// radio button but have the same name and id.
							value={props.value}
						/>
					</>
				);
			}}
		/>
	);
};

export default RadioButtonInput;
